import Zero2One from '@components/brand/zero2one'
import React from 'react'

const Zero2OnePage = () => {
  return <Zero2One />
}
export default Zero2OnePage
